import { Link } from 'react-router-dom';

import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import SecondHeader from '../SecondHeader/SecondHeader';

import './SchoolInfo.css';

const SchoolInfo = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };
  return (
    <>
      <Header />
      <SecondHeader />
      <main className="school-info">
        <div className="school-info__container">
          <h1 className="school-info__title">
            Основные сведения об образовательной организации ООО «Шахматная
            школа»
          </h1>
          <nav className="school-info__contents">
            <ol>
              <li>
                <a href="#section-osn_sved">Основные сведения</a>
              </li>

              <li>
                <a href="#section-organ_upr">
                  Структура и органы управления образовательной организацией
                </a>
              </li>

              <li>
                <a href="#section-docs">Документы</a>
              </li>

              <li>
                <a href="#section-obrazov">Образование</a>
              </li>

              <li>
                <a href="#section-rukovodstvo">
                  Руководство. Педагогический состав
                </a>
              </li>

              <li>
                <a href="#section-matteh">
                  Материально-техническое обеспечение и оснащённость
                  образовательного процесса
                </a>
              </li>

              <li>
                <a href="#section-platn_uslugi">
                  Платные образовательные услуги
                </a>
              </li>

              <li>
                <a href="#section-fin_hoz">
                  Финансово-хозяйственная деятельность
                </a>
              </li>

              <li>
                <a href="#section-vacant_mesta">
                  Вакантные места для приёма (перевода) обучающихся
                </a>
              </li>

              <li>
                <a href="#section-stipendii">
                  Стипендии и меры социальной поддержки
                </a>
              </li>

              <li>
                <a href="#section-international_colab">
                  Международное сотрудничество
                </a>
              </li>

              <li>
                <a href="#section-pitanie">
                  Организация питания в образовательной организации
                </a>
              </li>

              <li>
                <a href="#section-contact_info">Контактная информация</a>
              </li>

              <li>
                <a href="#section-news">Наши новости</a>
              </li>
            </ol>
          </nav>
          <section id="section-osn_sved" className="school-info__section">
            <h2>1. Основные сведения</h2>

            <p>
              <strong>Полное наименование образовательной организации:</strong>{' '}
              Структурное подразделение «Отделение дополнительного образования»
              ООО «Шахматная школа».
            </p>

            <p>
              <strong>Сокращённое наименование:</strong> ОДО ООО «Шахматная
              школа».
            </p>

            <p>
              <strong>Дата регистрации:</strong> 7 февраля 2019 года.
            </p>

            <p>
              <strong>Учредитель:</strong> ООО «Шахматная школа».
            </p>

            <p>
              <strong>Место нахождения образовательной организации:</strong>{' '}
              614016, Россия, Пермский край, г. Пермь, ул. Куйбышева, д. 54,
              офис 1.
            </p>

            <p>
              <strong>Режим работы:</strong>
            </p>

            <ul>
              <li>Понедельник – пятница: с 10:00 до 20:00.</li>
              <li>Суббота – воскресенье: с 10:00 до 14:00.</li>
            </ul>

            <p>
              <strong>Контактный телефон:</strong> +7 (342) 239-30-06.
            </p>

            <p>
              <strong>Адрес электронной почты:</strong>{' '}
              <a href="mailto:chessperm@yandex.ru">chessperm@yandex.ru</a>
            </p>
          </section>

          <section id="section-organ_upr" className="school-info__section">
            <h2>
              2. Структура и органы управления образовательной организацией
            </h2>

            <p>
              Управление образовательной организацией осуществляется
              руководством ООО «Шахматная школа» и структурного подразделения
              «Отделение дополнительного образования».
            </p>

            <h3>Руководящий состав:</h3>

            <ul>
              <li>Директор ООО «Шахматная школа» — Володин И.В.</li>
              <li>Исполнительный директор ОДО — Антонова О.П.</li>
              <li>Главный тренер — Терехин А.Н.</li>
            </ul>
          </section>

          <section id="section-docs" className="school-info__section">
            <h2>3. Документы</h2>

            <p>
              Образовательная деятельность осуществляется на основании лицензии
              на осуществление образовательной деятельности.
            </p>

            <h3>Лицензия:</h3>

            <ul>
              <li>
                <strong>Номер:</strong> 6340.
              </li>
              <li>
                <strong>Дата выдачи:</strong> 15 марта 2019 года.
              </li>
              <li>
                <strong>Серия:</strong> 59ЛО1.
              </li>
              <li>
                <strong>Номер бланка:</strong> 004297.
              </li>
              <li>
                <strong>Лицензирующий орган:</strong> Министерство образования и
                науки Пермского края.
              </li>
            </ul>
          </section>
          <h3>Ссылки на документы:</h3>

          <ul>
            <li>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%9F%D1%80%D0%B8%D0%BA%D0%B0%D0%B7%20%D0%BE%20%D1%81%D0%BE%D0%B7%D0%B4%D0%B0%D0%BD%D0%B8%D0%B8%20%D0%A1%D0%9F.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Приказ о создании структурного подразделения
              </a>
            </li>
            <li>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%9F%D0%BE%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BE%20%D1%81%D1%82%D1%80%D1%83%D0%BA%D1%82%D1%83%D1%80%D0%BD%D0%BE%D0%BC%20%D0%BF%D0%BE%D0%B4%D1%80%D0%B0%D0%B7%D0%B4%D0%B5%D0%BB%D0%B5%D0%BD%D0%B8%D0%B8.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Положение о структурном подразделении
              </a>
            </li>
            <li>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%202026%206400%20%D1%80%D1%83%D0%B1%D0%BB%D0%B5%D0%B8%CC%86.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Договор на месяц обучения (8 занятий)
              </a>
            </li>
            <li>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%94%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%202026%20%D1%88%D0%B0%D1%85%D0%BC%D0%B0%D1%82%D1%8B%203600%20%D1%80%D1%83%D0%B1%D0%BB%D0%B5%D0%B8%CC%86.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Договор на месяц обучения (4 занятия)
              </a>
            </li>
            <li>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%A0%D0%90%D0%A1%D0%9F%D0%98%D0%A1%D0%90%D0%9D%D0%98%D0%95%20%D0%9D%D0%90%202026%202027.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Расписание
              </a>
            </li>
            <li>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%9F%D1%80%D0%B5%D0%B8%CC%86%D1%81%D0%BA%D1%83%D1%80%D0%B0%D0%BD%D1%82_%D1%81%D1%82%D0%BE%D0%B8%D0%BC%D0%BEc%D1%82%D0%B8_%D0%BE%D0%B1%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D1%8F_%D0%B2_2026_%D0%B3.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Прейскурант цен на обучение
              </a>
            </li>
            <li>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%A1%D0%BF%D1%80%D0%B0%D0%B2%D0%BA%D0%B0_%D0%BE_%D0%BD%D0%B0%D0%BB%D0%B8%D1%87%D0%B8%D0%B8_%D0%BF%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC_%D0%A8%D0%A8_08_02_2019.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Справка о наличии программ
              </a>
            </li>
            <li>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%BB%D0%B8%D1%86%D0%B5%D0%BD%D0%B7%D0%B8%D1%8F.jpeg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Скан лицензии на осуществление образовательной деятельности
              </a>
            </li>
          </ul>
          <section id="section-obrazov" className="school-info__section">
            <h2>4. Образование</h2>

            <p>
              <strong>Вид образования:</strong> дополнительное образование.
            </p>

            <p>
              <strong>Дополнительные общеобразовательные программы:</strong>
            </p>

            <ol>
              <li>Комплексное интеллектуальное развитие.</li>
              <li>Программа спортивной подготовки «Шахматы».</li>
              <li>Шахматы на английском языке.</li>
              <li>Шахматы для взрослых.</li>
            </ol>

            <p>
              <strong>
                Дополнительные профессиональные программы повышения
                квалификации:
              </strong>
            </p>

            <ol>
              <li>Обучение детей шахматам в детских учреждениях.</li>
            </ol>
            <p>
              <strong>Формы обучения:</strong> очная и дистанционная.
            </p>

            <p>
              <strong>Язык обучения:</strong> русский.
            </p>

            <p>
              <strong>Нормативный срок обучения:</strong> устанавливается в
              каждой реализуемой образовательной программе.
            </p>

            <p>
              <strong>Календарный учебный график:</strong> утверждается
              оперативно, по мере комплектования и набора учебных групп.
            </p>

            <p>
              <strong>Количество обучающихся:</strong> количество обучающихся по
              договорам с юридическими и физическими лицами зависит от
              формирования учебных групп и расписания занятий.
            </p>
          </section>

          <section id="section-rukovodstvo" className="school-info__section">
            <h2>5. Руководство. Педагогический состав</h2>

            <p>
              Образовательную деятельность организует руководящий состав ОДО ООО
              «Шахматная школа».
            </p>

            <ul>
              <li>Директор ООО «Шахматная школа» — Володин И.В.</li>
              <li>Исполнительный директор ОДО — Антонова О.П.</li>
              <li>Главный тренер — Терехин А.Н.</li>
            </ul>

            <h3>Педагогический состав</h3>

            <p>
              Сведения о тренерах-преподавателях образовательной организации
              могут быть найдены в разделе{' '}
              <Link to="/#teachers">Наша команда</Link> на главной странице
              сайта.
            </p>
          </section>

          <section id="section-matteh" className="school-info__section">
            <h2>
              6. Материально-техническое обеспечение и оснащённость
              образовательного процесса
            </h2>

            <p>
              Материально-техническая база ОДО ООО «Шахматная школа» включает
              оборудование и технические средства, необходимые для организации и
              проведения образовательного процесса.
            </p>

            <p>
              <strong>В состав материально-технической базы входят:</strong>
            </p>

            <ul>
              <li>
                <strong>Шахматное оборудование:</strong> шахматы, шахматные
                доски, шахматные часы, демонстрационные доски.
              </li>
              <li>
                <strong>Компьютерное оборудование:</strong> технические средства
                для организации образовательного процесса.
              </li>
              <li>
                <strong>Периферийное оборудование:</strong> устройства,
                обеспечивающие работу компьютерной техники.
              </li>
              <li>
                <strong>Программное обеспечение:</strong> программные средства,
                используемые в образовательной деятельности.
              </li>
              <li>
                <strong>Каналы связи:</strong> средства коммуникации,
                необходимые для организации занятий, в том числе дистанционного
                обучения.
              </li>
            </ul>
          </section>

          <section id="section-platn_uslugi" className="school-info__section">
            <h2>7. Платные образовательные услуги</h2>
            <p>
              <a
                href="https://storage.yandexcloud.net/chess-school-site-docs/%D0%9F%D1%80%D0%B5%D0%B8%CC%86%D1%81%D0%BA%D1%83%D1%80%D0%B0%D0%BD%D1%82_%D1%81%D1%82%D0%BE%D0%B8%D0%BC%D0%BEc%D1%82%D0%B8_%D0%BE%D0%B1%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D1%8F_%D0%B2_2026_%D0%B3.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Документ с прейскурантом цен на обучение
              </a>
            </p>
          </section>

          <section id="section-fin_hoz" className="school-info__section">
            <h2>8. Финансово-хозяйственная деятельность</h2>

            <h3>Реквизиты организации</h3>

            <div className="school-info__table-wrapper">
              <table className="school-info__table">
                <tbody>
                  <tr>
                    <th>Наименование</th>
                    <td>ОДО ООО «Шахматная школа»</td>
                  </tr>
                  <tr>
                    <th>ИНН</th>
                    <td>5905026580</td>
                  </tr>
                  <tr>
                    <th>КПП</th>
                    <td>590401001</td>
                  </tr>
                  <tr>
                    <th>ОГРН</th>
                    <td>1155958015421</td>
                  </tr>
                  <tr>
                    <th>ОКАТО</th>
                    <td>57401380000</td>
                  </tr>
                  <tr>
                    <th>ОКПО</th>
                    <td>40896495</td>
                  </tr>
                  <tr>
                    <th>ОКОГУ</th>
                    <td>4210014</td>
                  </tr>
                  <tr>
                    <th>ОКФС</th>
                    <td>16</td>
                  </tr>
                  <tr>
                    <th>ОКОПФ</th>
                    <td>12300</td>
                  </tr>
                  <tr>
                    <th>ОКТМО</th>
                    <td>57701000001</td>
                  </tr>
                  <tr>
                    <th>Расчётный счёт</th>
                    <td>40702810849770001241</td>
                  </tr>
                  <tr>
                    <th>Банк</th>
                    <td>ВОЛГО-ВЯТСКИЙ БАНК ПАО СБЕРБАНК</td>
                  </tr>
                  <tr>
                    <th>БИК</th>
                    <td>042202603</td>
                  </tr>
                  <tr>
                    <th>Корреспондентский счёт</th>
                    <td>30101810900000000603</td>
                  </tr>
                  <tr>
                    <th>Директор</th>
                    <td>Володин И.В.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section id="section-vacant_mesta" className="school-info__section">
            <h2>9. Вакантные места для приёма (перевода) обучающихся</h2>

            <p>
              Набор обучающихся в группы и организация обучения осуществляются в
              течение всего календарного года по мере комплектования групп.
            </p>

            <p>
              Количество вакантных мест зависит от формирования групп и
              расписания занятий.
            </p>
          </section>

          <section id="section-stipendii" className="school-info__section">
            <h2>10. Стипендии и меры социальной поддержки</h2>

            <p>
              Стипендии и другие меры материальной поддержки обучающихся в ОДО
              ООО «Шахматная школа» не предусмотрены.
            </p>
          </section>

          <section
            id="section-international_colab"
            className="school-info__section"
          >
            <h2>11. Международное сотрудничество</h2>

            <p>Международное сотрудничество не осуществляется.</p>
          </section>
          <section id="section-pitanie" className="school-info__section">
            <h2>12. Организация питания в образовательной организации</h2>
            <p>Питание не предоставляется.</p>
          </section>
          <section id="section-contact_info" className="school-info__section">
            <h2>13. Контактная информация</h2>

            <p>
              <strong>ОДО ООО «Шахматная школа»</strong>
            </p>

            <p>
              <strong>Адрес:</strong>
              <br />
              614016, Россия, Пермский край, г. Пермь, ул. Куйбышева, д. 54,
              офис 1.
            </p>

            <p>
              <strong>Телефон:</strong>
              <br />
              <a href="tel:+73422393006">+7 (342) 239-30-06</a>
            </p>

            <p>
              <strong>Электронная почта:</strong>
              <br />
              <a href="mailto:chessperm@yandex.ru">chessperm@yandex.ru</a>
            </p>

            <p>
              <strong>Режим работы:</strong>
            </p>

            <ul>
              <li>Понедельник – пятница: 10:00–20:00.</li>
              <li>Суббота – воскресенье: 10:00–14:00.</li>
            </ul>
          </section>
          <section id="section-news" className="school-info__section">
            <h2>14. Наши новости</h2>
            <p>С новостями можно ознакомиться на главной странице сайта</p>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SchoolInfo;
